/**
 * Created by qs on 2021/3/16.
 */
import { EventEmitter } from "events";
export default new EventEmitter();
